import {
  RECEIVE_TAGS,
  REQUEST_TAGS,
  // SET_LAST_VISIT
} from '../action_constants'

// const date = new Date()
// date.setTime(date.getTime() - 15 * 24 * 3600 * 1000)

export default function tags(
  state = {
    isLoading: false,
    // lastVisit: date.getTime(),
    tag: null,
    tags: null,
  },
  action
) {
  switch (action.type) {
    case REQUEST_TAGS:
      return {
        ...state,
        tag: action.tag,
        isLoading: true,
      }
    case RECEIVE_TAGS:
      return {
        ...state,
        tags: action.tags,
        isLoading: false,
      }
    // case SET_LAST_VISIT:
    //   return {
    //     ...state,
    //     lastVisit: action.payload,
    //   }
    default:
      return state
  }
}
